import Loader from "@components/global/Loader/Loader";
import MinerName from "@components/global/new/MinerName/MinerName";
import mainLocationsStore from "@mobx/store/locations";
import { ItemStore } from "@mobx/store/locations/interfaces";
import { IRackItem3 } from "@mobx/store/locations/types";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useRef, useState } from "react";
import BackIcon3 from "../BackIcon3";
import styles from "./Back.module.scss";

export interface IBack3Props {
  itemStore: ItemStore;
}

const useControl = (props: IBack3Props) => {
  const leaveCount = useRef(0);
  const prevEq = useRef<typeof rotateEq>();
  const rackItem = props.itemStore.item as IRackItem3;
  const [draggingOver, setDraggingOver] = useState(false);
  const [rotateEq, setRotateEq] = useState<typeof window.WORK_EQUIPMENT>();
  const buildingStore = mainLocationsStore.activeLocation!.activeBuilding!;
  const rackStore = props.itemStore.rackStore;

  const onMouseEnter = () => {
    console.log(window.WORK_EQUIPMENT);
    if (!window.WORK_EQUIPMENT) return;
    leaveCount.current++;
    setDraggingOver(true);
    setRotateEq(window.WORK_EQUIPMENT);
  };

  const onMouseLeave = () => {
    leaveCount.current--;

    if (leaveCount.current === 0) {
      setRotateEq(undefined);
      setDraggingOver(false);
    }
  };

  const onMouseUp = async () => {
    if (!window.WORK_EQUIPMENT || !rotateEq) return;

    const askUser = !!rackItem.types && !!rackItem.types.find((t) => t.type === rotateEq?.type);
    const r = await rackStore.addItemEquipment(askUser, rackItem.id, props.itemStore.itemIndex, rotateEq);
    setDraggingOver(false);
    if (!r) {
      setRotateEq(prevEq.current);
      return;
    }

    prevEq.current = rotateEq;
    buildingStore.setCanUndo();
    if (!askUser) onMouseLeave();
  };

  return {
    draggingOver,
    rackItem,

    onMouseEnter,
    onMouseLeave,
    onMouseUp,
  };
};


const Back3 = observer((props: IBack3Props) => {
  const ctrl = useControl(props);
  return (
    <div
      className={cn(styles.wrapper, {
        [styles.dragging_over]: ctrl.draggingOver,
      })}
      style={{
        borderColor: ctrl.rackItem.merge
          ? ctrl.rackItem.user_color
          : undefined,
      }}
      onDragEnter={ctrl.onMouseEnter}
      onDragLeave={ctrl.onMouseLeave}
      onDrop={ctrl.onMouseUp}
    >
      {props.itemStore.isLoading && <Loader size={24} />}
      <MinerName>{ctrl.rackItem.miner_name}</MinerName>
      <div className={styles.rotate_icons}>
        <BackIcon3 item={ctrl.rackItem} type={EQUIPMENT_TYPE.NETWORK} />
        <BackIcon3 item={ctrl.rackItem} type={EQUIPMENT_TYPE.ELECTRICAL} />
      </div>
      <div
        className={styles.bottom}
        style={{ backgroundColor: ctrl.rackItem.user_color }}
      />
    </div>
  );
});

Back3.displayName = "Back3";

export default Back3;